module.exports = __webpack_public_path__ + "assets/img/GLJY-1.d3999f31.jpg";